<nav #header class="fixed-top" style="background-color: white;filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerMenu navbar-collapse collapse">
        <div>
            <a href="https://ecuadorfamilytours.com/?lang=es" target="_blank">
                <img class="logo" src="../assets/images/logos-header/eft.svg" />
            </a>
        </div>
        <div style="display: flex;align-items: center;">
            <div class="mobileBookNow">
                <i class="fa fa-search" style="padding: 0 10px;"></i>
                <a class="rightButton" href="http://ecuadorfamilytour.com/book-now/">Book Now</a>
            </div>
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
        </div>

    </div>
    <div #header1 class="containerHeader" [ngClass]="showMenu ? 'showMenu':''"
        style="border-top: 1px solid rgb(98, 98, 98, 0.15);">
        <ul class="navbar-nav">
            <li class="nav-item menuItem"><a href="https://ecuadorfamilytours.com/?lang=es" target="_blank">Home</a>
            </li>
            <li class="nav-item menuItem"><a href="http://ecuadorfamilytour.com/#about" target="_blank">About Us</a>
            </li>
            <li class="nav-item menuItem"><a href="http://ecuadorfamilytour.com/#tours" target="_blank">Our
                    Tours</a></li>
            <li class="nav-item menuItem"><a href="https://ecuadorfamilytours.com/paquetes-y-promociones/?lang=es"
                    target="_blank">Packages
                    & Promotions</a></li>
            <li class="nav-item menuItem"><a href="https://ecuadorfamilytours.com/?lang=es#Footer"
                    target="_blank">Gallery</a></li>
            <li class="nav-item menuItem last"><a href="https://ecuadorfamilytours.com/?lang=es#Footer"
                    target="_blank">Contact
                    Us</a>
            </li>
        </ul>
        <div class="bookNow">
            <i class="fa fa-search" style="padding: 0 10px;"></i>
            <a class="rightButton" href="http://ecuadorfamilytour.com/book-now/">Book Now</a>
        </div>

        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
            <app-heart-header></app-heart-header>
        </div>
    </div>
</nav>